import { render, staticRenderFns } from "./collectTickets.vue?vue&type=template&id=753dd056&scoped=true"
import script from "./collectTickets.vue?vue&type=script&lang=js"
export * from "./collectTickets.vue?vue&type=script&lang=js"
import style0 from "./collectTickets.vue?vue&type=style&index=0&id=753dd056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753dd056",
  null
  
)

export default component.exports